module.exports = __webpack_public_path__ + "static/media/case2.7121ee90.png";